import * as React from "react";
import { BrComponentContext, BrPageContext } from "@bloomreach/react-sdk";
function useBrPageContext() {
  return React.useContext(BrPageContext);
}
function useBrComponentContext() {
  return React.useContext(BrComponentContext);
}
export {
  useBrComponentContext,
  useBrPageContext
};
//# sourceMappingURL=context.js.map
